(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("FaceDetector", [], factory);
	else if(typeof exports === 'object')
		exports["FaceDetector"] = factory();
	else
		root["FaceDetector"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition